import {
    CHANGE_LIST_OPEN_MODAL,
    CHANGE_LIST_SEARCH_REQUEST,
    CHANGE_LIST_SEARCH_RESULT,
    CHANGE_LIST_SEARCH_SUBUSERS_REQUEST,
    CHANGE_LIST_SEARCH_SUBUSERS_RESULT,
} from 'Redux/actionTypes';

export const changeListOpenModal = (open, data) => ({
    type: CHANGE_LIST_OPEN_MODAL,
    payload: { open, data }
})

export const changeListSearchRequest = (filters) => ({
    type: CHANGE_LIST_SEARCH_REQUEST,
    payload: { filters }
})

export const changeListSearchResult = (data) => ({
    type: CHANGE_LIST_SEARCH_RESULT,
    payload: { data }
})


export const changeListSearchSubUsersRequest = (companyId) => ({
    type: CHANGE_LIST_SEARCH_SUBUSERS_REQUEST,
    payload: { companyId }
})

export const changeListSearchSubUsersResult = (data) => ({
    type: CHANGE_LIST_SEARCH_SUBUSERS_RESULT,
    payload: { data }
})

